import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconTranslationChanged = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" sx={{ fill: 'none', ...props.sx }}>
    <path
      d="M1.97021 7.65894L13.9821 7.65894"
      stroke="#FFAB00"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10.9912 7.75391C10.0489 13.346 6.8423 15.9926 1.96669 16.156"
      stroke="#FFAB00"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.71229 10.9332C7.81385 14.7129 9.90407 15.8082 13.6612 16.0848"
      stroke="#FFAB00"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.22638 7.6576L7.22505 8.4076L8.72505 8.41026L8.72637 7.66026L7.22638 7.6576ZM8.73071 5.21129C8.73145 4.79708 8.39625 4.4607 7.98204 4.45996C7.56783 4.45923 7.23145 4.79442 7.23071 5.20863L8.73071 5.21129ZM8.72637 7.66026L8.73071 5.21129L7.23071 5.20863L7.22638 7.6576L8.72637 7.66026Z"
      fill="#FFAB00"
    />
    <path
      d="M10.874 22.0039L12.4489 18.7872M20.8042 22.0039L19.1963 18.7872M12.4489 18.7872L15.7877 11.9676L19.1963 18.7872M12.4489 18.7872H19.1963"
      stroke="#FFAB00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0022 4.20992C16.0022 4.20992 16.6352 3.34749 17.1494 2.8329C17.6636 2.31831 18.3743 2 19.1592 2C20.7285 2 22.0006 3.27211 22.0006 4.84133C22.0006 6.41055 20.7285 7.68266 19.1592 7.68266C18.1741 7.68266 17.3061 7.18131 16.7964 6.41985M16.0022 4.20992V2.3157M16.0022 4.20992H17.8964"
      stroke="#FFAB00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
